import React, { useEffect } from "react";

const DateInput = ({
  label,
  register,
  errors,
  name,
  defaultValue = "",
  setValue,
  ...rest
}) => {
  useEffect(() => {
    if (defaultValue && setValue) {
      setValue(name, defaultValue);
    }
  }, [defaultValue, name, setValue]);
  return (
    <div className="cursor-pointer">
      <label className="block font-bold">{label}</label>
      <input
        type="date"
        defaultValue={defaultValue} // Ensure default value is set
        {...register(name, { required: "Required" })} // Register the input
        className="border p-2 w-full rounded-md"
        {...rest}
      />
      {errors[name] && (
        <p className="text-red-500 text-sm">{errors[name]?.message}</p>
      )}
    </div>
  );
};

export default DateInput;
